import { useEffect, useState } from 'react';
import { getNoticeList } from '../../api';
import { useHistory } from 'react-router-dom';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import './style.scoped.less';

const second = 0.4;

interface NoticeItem {
  id: number;
  title: string;
}

const NoticeBoard = () => {
  const [notice, setNotice] = useState<NoticeItem | undefined>();
  const history = useHistory();
  const getNoticeData = () => {
    const data = {
      is_home_page: 0,
      page: 1,
      page_size: 10,
      category_id: 2001,
    };
    getNoticeList({ data }).then((res) => {
      if (res.code === 0) {
        setNotice(res.data.list[0]);
      }
    });
  };

  useEffect(() => {
    getNoticeData();
  }, []);

  const onClick = () => {
    const url = `/agency/notice/${(notice as NoticeItem).id}`;
    reportUserBehaviorCgi({
      data: {
        behavior: '查看首页通知',
        page1: '概览',
        relation_id: `${window.location.origin}${REACT_APP_PUBLIC_URL}${url}`,
        relation_name: notice?.title,
      },
    });
    history.push(url);
  };

  const NoticeBoardInfo = () => {
    const time = Math.floor(second * (notice as NoticeItem)?.title?.length);
    return (
      <div className='notice-board-item'>
        <div
          onClick={onClick}
          className='notice-board-info'
          style={{ animationDuration: `${time}s` }}
          data-report-global="notice-board"
        >
        {notice?.title}
        </div>
      </div>
    );
  };

  if (notice && notice.id) {
    return (
      <div className="notice-board">
        <span className='notice-new'><span>NEW</span></span>
        {NoticeBoardInfo()}
      </div>
    );
  }

  return null;
};

export default NoticeBoard;
